var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmojiNoEmo = function SvgEmojiNoEmo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36 18c0-9.941-8.059-18-18-18S0 8.059 0 18s8.059 18 18 18 18-8.059 18-18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M35 18c0-9.389-7.611-17-17-17S1 8.611 1 18s7.611 17 17 17 17-7.611 17-17Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.84 24.228a.83.83 0 0 1-.84-.84.83.83 0 0 1 .84-.84h16.321a.83.83 0 0 1 .84.84.83.83 0 0 1-.84.84zm14.825-7.111a1.827 1.827 0 0 1-1.837-1.837v-1.443A1.825 1.825 0 0 1 24.665 12h.026a1.827 1.827 0 0 1 1.837 1.837v1.443a1.826 1.826 0 0 1-1.837 1.837zm-13.33 0a1.825 1.825 0 0 1-1.836-1.837v-1.443A1.825 1.825 0 0 1 11.335 12h.027a1.826 1.826 0 0 1 1.836 1.837v1.443a1.825 1.825 0 0 1-1.836 1.837z"
  })));
};
export default SvgEmojiNoEmo;